import { Navbar } from 'rsuite'
import { useMemo } from 'react'
import style from './header.module.scss'
import LanguageOverlay from './languageOverlay'
import { useSelector, useDispatch } from 'react-redux'
import { configSelectors } from '@/store/configs'
import { useState, useCallback } from 'react'
import useBodyScrollLock from '@/hooks/useBodyScrollLock'
import DesktopHeader from './desktopHeader'
import MobileHeader from './mobileHeader'
import { headerActions } from '@/store/header'
import { customerHelper } from '@tweddle-se-team/common/constants'

const { CUSTOMER_IDS } = customerHelper

const canSwitchLanguageByCustomer = {
  [CUSTOMER_IDS.SUBARU]: languages => Object.keys(languages || {}).length > 1,
  [CUSTOMER_IDS.NORDICS]: () => false
}

const showLogoHeaderByCustomer = {
  [CUSTOMER_IDS.SUBARU]: () => true,
  [CUSTOMER_IDS.NORDICS]: ({ isInFrame }) => !isInFrame
}

function Header({
  changeLocale: changeLocaleCallback = () => {},
  returnToLandingPage: returnToLandingPageCallback = () => {},
  autentincatedOptions,
  isOnline,
  customerId,
  locale
}) {
  const [showLanguageSelector, setShowLanguageSelector] = useState(false)

  const languages = useSelector(configSelectors.selectConfigByKey('languages'))
  const isInFrame = useSelector(configSelectors.selectIsInFrame)
  const canSwitchLanguage = useMemo(() => {
    const canSwitchLanguageForCustomer =
      canSwitchLanguageByCustomer[customerId] || canSwitchLanguageByCustomer[CUSTOMER_IDS.SUBARU]
    return canSwitchLanguageForCustomer(languages)
  }, [customerId, languages])
  const showLogoHeader = useMemo(() => {
    const showLogoHeaderForCustomer =
      showLogoHeaderByCustomer[customerId] || showLogoHeaderByCustomer[CUSTOMER_IDS.SUBARU]
    return showLogoHeaderForCustomer({ isInFrame })
  }, [customerId, isInFrame])

  // Disable body scroll when LanguageOverlay is open
  useBodyScrollLock(canSwitchLanguage && showLanguageSelector)
  const dispatch = useDispatch()
  const changeLocale = useCallback(
    locale => {
      changeLocaleCallback(locale)
      setShowLanguageSelector(false)
    },
    [changeLocaleCallback]
  )

  const resetVehicle = useCallback(() => {
    dispatch(
      headerActions.SET_MODEL({
        brand: null,
        model: null,
        modelType: null,
        year: null,
        language: null,
        image: null
      })
    )
  }, [dispatch])

  const returnToLandingPage = useCallback(
    (e, isOnline) => {
      returnToLandingPageCallback?.(e, isOnline)
      resetVehicle()
    },
    [returnToLandingPageCallback, resetVehicle]
  )

  return (
    <>
      <Navbar className={style.navbar} id={`navbar-${customerId}`}>
        <DesktopHeader
          returnToLandingPage={returnToLandingPage}
          changeLocale={changeLocale}
          autentincatedOptions={autentincatedOptions}
          isOnline={isOnline}
          customerId={customerId}
          locale={locale}
          setShowLanguageSelector={setShowLanguageSelector}
          resetVehicle={resetVehicle}
          canSwitchLanguage={canSwitchLanguage}
          showLogoHeader={showLogoHeader}
        />
        <MobileHeader
          returnToLandingPage={returnToLandingPage}
          changeLocale={changeLocale}
          isOnline={isOnline}
          customerId={customerId}
          locale={locale}
          setShowLanguageSelector={setShowLanguageSelector}
          resetVehicle={resetVehicle}
          canSwitchLanguage={canSwitchLanguage}
          showLogoHeader={showLogoHeader}
        />
      </Navbar>
      <LanguageOverlay
        open={canSwitchLanguage && showLanguageSelector}
        onClose={() => setShowLanguageSelector(false)}
        locale={locale}
        changeLocale={changeLocale}
        languages={languages}
      />
    </>
  )
}

export default Header
